export const spaces = [
  { id: "learn", icon: "✦", label: "Apprendre et réciter" },
  { id: "professor", icon: "🎓", label: "Espace professeur" },
  { id: "investor", icon: "📈", label: "Présentation investisseurs" },
];

export const profiles = [
  { id: "child", icon: "🌙", label: "Enfant", subtitle: "J’écoute, je répète, je réussis", color: "sun" },
  { id: "beginner", icon: "🌱", label: "Débutant", subtitle: "Des bases claires, pas à pas", color: "mint" },
  { id: "adult", icon: "🧭", label: "Adulte", subtitle: "Un apprentissage guidé et pratique", color: "blue" },
  { id: "confirmed", icon: "⭐", label: "Confirmé", subtitle: "Nuances, précision et maîtrise", color: "gold" },
  { id: "teacher", icon: "📚", label: "Enseignant", subtitle: "Règles, preuves et approfondissement", color: "ink" },
];

export const labels = {
  al_fatiha: "Al-Fātiḥa · الفاتحة",
  al_ikhlas: "Al-Ikhlāṣ · الإخلاص",
  al_falaq: "Al-Falaq · الفلق",
  an_nas: "An-Nās · الناس",
  tajweed_target_005_106: "Al-Māʾidah · verset 106",
  tajweed_target_007_001: "Al-Aʿrāf · verset 1",
  tajweed_target_009_127: "At-Tawbah · verset 127",
  tajweed_target_010_051: "Yūnus · verset 51",
  tajweed_target_017_111: "Al-Isrāʾ · verset 111",
  tajweed_target_024_033: "An-Nūr · verset 33",
  tajweed_target_051_047: "Adh-Dhāriyāt · verset 47",
  tajweed_target_106_004: "Quraysh · verset 4",
  tajweed_target_111_001: "Al-Masad · verset 1",
};

export const glossary = "Kalima : mot ou parole · Ism : nom · Harf : lettre ou particule · Âya : verset ou signe · Sourate : chapitre du Coran.";
